<template>
  <!-- This component renders a group inside the main nav list.
       It intentionally outputs an <li> so it can be placed directly
       inside the existing `.nav-list` markup. -->
  <li class="nav-group" :class="{ closed: !open, 'sidebar-collapsed': collapsed }">
    <div
      class="nav-group-header"
      role="button"
      :aria-expanded="String(open)"
      @click="toggle"
      @keydown.enter.prevent="toggle"
      tabindex="0"
    >
      <div class="nav-icon">
        <slot name="icon" />
      </div>

      <p class="nav-group-title" v-if="!collapsed">{{ title }}</p>

      <div class="nav-group-chevron" aria-hidden v-if="!collapsed">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M6 9l6 6 6-6" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
      </div>
    </div>

    <transition name="collapse">
      <ul v-show="open" class="nav-list nav-group-items">
        <slot />
      </ul>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'SidebarGroupUi',
  props: {
    title: { type: String, default: '' },
    initialOpen: { type: Boolean, default: true },
    // pass parent's collapsed state so group can hide title when sidebar is collapsed
    collapsed: { type: Boolean, default: false },
  },
  data() {
    return { open: Boolean(this.initialOpen) };
  },
  methods: {
    toggle() {
      this.open = !this.open;
      this.$emit('update:open', this.open);
    },
  },
};
</script>

<style scoped>
.nav-group { margin-bottom: 0.5rem; list-style: none; }
.nav-group-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: var(--text-secondary);
  border-radius: 8px;
}
.nav-group-header:focus { outline: none; box-shadow: 0 0 0 3px rgba(0,0,0,0.04); }
.nav-group-header:hover { color: var(--text-primary); background: var(--surface-light); }
.nav-group-title { flex: 1; font-weight: 600; font-size: 0.85rem; margin-left: 0.5rem; }
.nav-group-chevron { margin-left: auto; transition: transform 0.18s ease; color: var(--text-secondary); }
.nav-group.closed .nav-group-chevron { transform: rotate(-90deg); }
.nav-group-items { padding-left: 0.25rem; margin: 0.25rem 0 0 0; }

/* make the icon visible and center header when sidebar is collapsed */
.nav-icon { width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; }
.nav-icon img { width: 20px; height: 20px; }
.nav-group.sidebar-collapsed .nav-group-header { justify-content: center; }
.nav-group.sidebar-collapsed .nav-group-title { display: none; }
.nav-group.sidebar-collapsed .nav-group-chevron { display: none; }

/* simple collapse transition (height) */
.collapse-enter-active, .collapse-leave-active { transition: max-height 0.18s ease, opacity 0.12s ease; overflow: hidden; }
.collapse-enter-from, .collapse-leave-to { max-height: 0; opacity: 0; }
.collapse-enter-to, .collapse-leave-from { max-height: 800px; opacity: 1; }

</style>
